import React, { ReactElement, useEffect } from 'react';
import { useDataCollection } from '../../../../hooks';
import CheckCard from '../../../components/Form/CheckCard';
import { InjectedWizardStepProps } from '../../../components/Steps/WizardStep';
import StepHeader from '../../../components/Layout/StepHeader';
import { houseFloorPlaneShapeOptions } from '../../../../data/enumerations';
import { Form } from 'formik';

const StepHouseFloorPlaneShape = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, values } = useDataCollection();

    useEffect(() => {
        if (values.floorPlanShape) {
            completeStep && completeStep(true);
        }
    }, [values, completeStep]);

    return (
        <Form>
            <StepHeader title="Jaký půdorys má Váš dům?" />
            <div className={'wiz-card wiz-card--small'}>
                <div className={'wiz-card__inner'}>
                    {houseFloorPlaneShapeOptions.map((option) => {
                        return (
                            <div key={option.value} className={'wiz-card-item'}>
                                <CheckCard
                                    name={'floorPlanShape'}
                                    onChange={handleChange}
                                    checked={values.floorPlanShape === option.value}
                                    value={option.value}
                                    img={option.img}
                                    title={option.title}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </Form>
    );
};

export default StepHouseFloorPlaneShape;
